export enum ServerActionTypes {
  SET_TIMESTAMP = '@@server/SET_TIMESTAMP',
}

export interface ServerStateTypes {
  timestamp: number
}
